import { ConfigSettings } from "@simplyhealth/iam_client_lib";
import { fromQueryParameters } from "./query-parameters-helper";

export function createCognitoConfigSettings(): ConfigSettings {
  return {
    region: ensureString(process.env.REACT_APP_COGNITO_REGION),
    userPoolId: ensureString(process.env.REACT_APP_COGNITO_USER_POOL_ID),
    userPoolWebClientId: ensureString(fromQueryParameters().getAppClientId()),
    checkRegistrationUrl: ensureString(process.env.REACT_APP_CHECK_REGISTRATION_API)
  };
}

function ensureString(value: string | undefined | null): string {
  return value ? value : "";
}
